import { render } from "./OptionsTab.vue?vue&type=template&id=e5fa8800"
import script from "./OptionsTab.vue?vue&type=script&lang=ts"
export * from "./OptionsTab.vue?vue&type=script&lang=ts"

import "./OptionsTab.vue?vue&type=style&index=0&id=e5fa8800&lang=scss"
script.render = render

export default script